import React from 'react'

import { ContentWithOffset } from '../../components/scharedStyles/style'
import EditScheduleFilters from './EditScheduleFilters'
import EditScheduleList from './EditScheduleList'
import EditScheduleModals from './EditScheduleModals'
import EditScheduleToolbar from './EditScheduleToolbar'
import { PageLayout } from './style'
import { useEditScheduleEffects } from './hooks'

const EditSchedule = () => {
    useEditScheduleEffects()

    return (
        <>
            <EditScheduleModals />

            <ContentWithOffset>
                <EditScheduleToolbar />

                <PageLayout>
                    <EditScheduleFilters />
                    <EditScheduleList />
                </PageLayout>
            </ContentWithOffset>
        </>
    )
}

export default EditSchedule
